// Plāns fetch apvalks: JSON, sesijas sīkfails un CSRF galvene katram pieprasījumam.

export class ApiError extends Error {
  constructor(public status: number, message: string, public code = 'error') {
    super(message);
  }
}

type Body = FormData | Record<string, unknown> | undefined;

async function request<T>(method: string, url: string, body?: Body): Promise<T> {
  const headers: Record<string, string> = { 'x-balansa': '1' };
  let payload: BodyInit | undefined;
  if (body instanceof FormData) payload = body;
  else if (body !== undefined) {
    headers['content-type'] = 'application/json';
    payload = JSON.stringify(body);
  }
  let r: Response;
  try {
    r = await fetch('/api' + url, { method, headers, body: payload, credentials: 'same-origin' });
  } catch {
    throw new ApiError(0, 'Nav savienojuma ar serveri.', 'network');
  }
  const isJson = (r.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await r.json().catch(() => null) : null;
  if (!r.ok) {
    const msg = (data && typeof data.message === 'string' && data.message) || `Servera kļūda (${r.status}).`;
    throw new ApiError(r.status, msg, (data && data.error) || 'error');
  }
  return data as T;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyJson = Record<string, any>;

export const api = {
  get: <T = AnyJson>(url: string) => request<T>('GET', url),
  post: <T = AnyJson>(url: string, body?: Body) => request<T>('POST', url, body ?? {}),
  patch: <T = AnyJson>(url: string, body?: Body) => request<T>('PATCH', url, body ?? {}),
  del: <T = AnyJson>(url: string, body?: Body) => request<T>('DELETE', url, body)
};

/**
 * Kārts attēla adrese. Pēc noklusējuma — WebP sīktēls (ātri ielādējams kāršu attēlošanai), `original` — augšupielādētais
 * oriģināls (ADR 0013).
 */
export const imageUrl = (file: string | null | undefined, size: 'thumb' | 'original' = 'thumb') =>
  file ? '/api/images/' + encodeURIComponent(file) + (size === 'thumb' ? '?size=thumb' : '') : '';
